import athenaConfig from '../../config';
import BarcodePushCustomizer from './barcode-push';
import EnrollTotpCustomizer from './enroll-totp';
import EnrollManualPushCustomizer from './enroll-manual-push';
import EnrollActivationLinkSentCustomizer from './enroll-activation-link-sent';
import { CustomizeControllerArgs } from '../';
import BaseGroupCustomizer from '../base-group-customizer';
import BaseCustomizer from '../base';
import { getSelectedProvider } from '../../utils/widget-facade';
import ActivatePushClassicCustomizer from './activate-push';

const { classic } = athenaConfig;

export default class OktaVerifyEnrollClassicCustomizer extends BaseGroupCustomizer {
  getGroupedCustomizers(initArgs: CustomizeControllerArgs): BaseCustomizer[] {
    return [
      new EnrollTotpCustomizer(initArgs),
      new BarcodePushCustomizer(initArgs),
      new EnrollManualPushCustomizer(initArgs),
      new EnrollActivationLinkSentCustomizer(initArgs),
      new ActivatePushClassicCustomizer(initArgs),
    ];
  }

  async shouldGroupCustomize() {
    return classic && getSelectedProvider() === 'OKTA';
  }
}
